module.exports = __webpack_public_path__ + "assets/images/frame-br-2.f45c44d85d6ed4a0b781aef5e267a2ee.png";